export const SIGN_UP = '/signup';
export const FIND_AUDIO = '/library';
export const ADD_AUDIO = '/manage-library';
export const EDIT_AUDIO = '/edit-track';
export const SIGN_IN = '/';
export const HOME = '/home';
export const ACCOUNT = '/account';
export const ADMIN = '/admin';
export const ADMINUSERS = '/admin';
export const ADMINFIELDS = '/admin/fields';
export const PASSWORD_FORGET = '/forgot-password';
export const ADMINCHATBOT = '/admin/chatbot'; //chatbot feature
export const ADMINANALYTICS = '/admin/analytics';
export const ADMINREPORTING = '/admin/reporting';
export const INVITE = '/invite/:code';
export const CLAIM_LICENSE = '/claim/:claimCode';
export const SELECT_ORGANIZATION = '/select-organization';
export const GET_STARTED = '/get-started';
export const PUBLIC_CATALOGUE = '/public-tracks';
